<template>
    <div>
        <div class="form-group">
            <label for="name">Name</label>
            <div class="input-group">
                <input
                    id="name"
                    v-model="name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': $v.name.$error }"
                    placeholder="Name"
                />
            </div>
        </div>
        <div class="form-group">
            <label for="alt">Alt text</label>
            <div class="input-group">
                <input
                    id="alt"
                    v-model="alt"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': $v.alt.$error }"
                    placeholder="Alt text"
                />
            </div>
        </div>
        <div>
            <div
                class="image-preview"
                :class="{
                    'details-only': !preview
                }"
            >
                <div v-if="preview" v-media-url.controls="media" />
                <div
                    class="media-details"
                    :class="{
                        'details-only': !preview
                    }"
                >
                    <div class="details-item">
                        <b>Size:</b> {{ media.size }}B
                    </div>
                    <template v-if="media.type === 'image'">
                        <div class="details-item">
                            <b>Width:</b> {{ media.meta.width }}px
                        </div>
                        <div class="details-item">
                            <b>Height:</b> {{ media.meta.height }}px
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div
            class="d-flex"
            :class="preview ? 'justify-content-between' : 'justify-content-end'"
        >
            <button
                v-if="preview"
                type="button"
                class="btn btn-danger waves-effect waves-light mr-1"
                @click="cancel"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn btn-info waves-effect waves-light mx-1"
                @click="downloadFile"
            >
                Download
            </button>
            <router-link
                v-if="isCroppable"
                :to="cropUrl"
                type="button"
                class="btn btn-primary waves-effect waves-light mx-1"
            >
                Crop
            </router-link>
            <button
                type="button"
                class="btn btn-success waves-effect waves-light ml-1"
                @click="updateHandler"
            >
                Update
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
    validations: {
        name: {
            required
        },
        alt: {
            required
        }
    },

    props: {
        media: {
            type: Object,
            required: true
        },
        preview: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            name: '',
            alt: ''
        };
    },

    computed: {
        isCroppable() {
            return (
                this.media.type === 'image' &&
                !['svg', 'gif'].includes(this.media.extension)
            );
        },

        cropUrl() {
            return `/media/${this.media.id}/crop`;
        }
    },

    watch: {
        media: {
            handler() {
                this.name = this.media.name;
                this.alt = this.media.alt;
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions({
            updateMedia: 'media/update'
        }),

        async updateHandler() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                const media = await this.updateMedia({
                    id: this.media.id,
                    name: this.name,
                    alt: this.alt
                });

                this.$toaster('File has been updated.');

                this.$emit('updated', media);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        },

        cancel() {
            this.$emit('cancel');
        },

        downloadFile() {
            this.$downloadFile(
                this.$getFileUrl(this.media),
                this.media.name,
                ['video', 'image', 'pdf', 'audio'].includes(this.media.type)
            );
        }
    }
};
</script>
